<template>
  <div id="main_login_signup">
    <div class="login_signup_container">
        
        <div class="head" v-if="actionType === 'signup' || actionType === 'thanks'">
            <div class="signup_type_steps">
                <div class="signup_type">
                    <p>הרשמה למכרז השקוף</p>
                    <span v-text="signup_for === 'entrepreneur' ? 'יזמים' : 'עורכי דין'"></span>
                </div>
                <div class="steps" v-if="actionType !== 'thanks'">
                    <span>שלב</span>
                    <!-- <span class="step" v-text="step"></span> -->
                    <span class="step" > <input type="number" min="0" v-model="step" style="max-width: 20px;"></span>
                    <span>מתוך</span>
                    <span>4</span>
                </div>
            </div>
            <div class="login_btn">
                <div class="top">
                    <p>כבר נרשמת? </p>
                    <a @click="actionType = 'login'; signupDataLoading = true;">להתחברות</a>
                </div>
                <router-link to="/">חזרה לדף הבית</router-link>
            </div>
        </div>
        <Login @signup="goToSign($event)" v-if="actionType === 'login'"/>
        <template v-if="actionType === 'signup'">
            <div class="signup_container">
                <div id="signup">
                    <div class="back" v-if="step > 1">
                        <div class="arrow_container" @click="step -= 1"><span class="arrow_icon"></span></div>
                        <p>חזרה לשלב הקודם</p>
                    </div>
                    <div class="step_container">
                        <template v-if="signup_for === 'entrepreneur' && !signupDataLoading">
                            <EntrepreneurStepA :updatedData="formData" @next="handleNext" v-show="step === 1"/>
                            <EntrepreneurStepB :key="step" :updatedData="formData" @next="handleNext" v-show="step === 2"/>
                            <EntrepreneurStepC :key="step" :updatedData="formData" @next="handleNext" v-show="step === 3"/>
                            <EntrepreneurStepD :key="step" :updatedData="formData" @next="handleNext" v-show="step === 4"/>
                        </template>
                        <template v-if="signup_for === 'lawyer' && !signupDataLoading">
                            <LawyerStepA :updatedData="formData" @next="handleNext" v-show="step === 1"/>
                            <LawyerStepB :key="step" :updatedData="formData" @next="handleNext" v-show="step === 2"/>
                            <LawyerStepC :key="step" :updatedData="formData" @next="handleNext" v-show="step === 3"/>
                            <LawyerStepD :key="step" :updatedData="formData" @next="handleNext" v-show="step === 4"/>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="actionType === 'thanks'">
            <signupThanksVue :name="steps[0].contact_name"/>
        </template>
    </div>

    <div class="text_logo_container">
        <video autoplay muted loop id="background-video">
            <source src="../assets/8328.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <div class="main_logo_text">
            <div class="logo"></div>
            <div class="text">
                <p>יעילות. מקצועיות. חשיפה.</p>
                <p>יותר פרויקטים בהתחדשות עירונית.</p>
            </div>
        </div>
        <div class="widget" v-if="currentWidget" :class="'type_' + currentWidget.widget_type">
            <transition name="fade_s"  mode="out-in">
                <div class="list_widget" v-if="currentWidget.widget_type == 'list'">
                    <div class="widget_title" v-text="currentWidget.title"></div>
                    <div class="list_container" v-html="currentWidget.text_con"></div>
                </div>
            </transition>
            <transition name="fade_s"  mode="out-in">
                <div class="privet_widget" v-if="currentWidget.widget_type == 'privet'">
                    <div class="text_lines_container">
                        <div class="lines"></div>
                        <div class="content" v-html="currentWidget.text_con"></div>
                    </div>
                    <div class="profile">
                        <div class="pic" :style="'--local_url: url(' + currentWidget.pic_parsed + ');'"></div>
                        <div class="text_con">
                            <div class="name" v-text="currentWidget.name"></div>
                            <div class="description" v-text="currentWidget.description"></div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade_s" mode="out-in">
                <div class="company_widget" v-if="currentWidget.widget_type == 'company'">
                    <div class="profile">
                        <div class="pic" :style="'--local_url: url(' + currentWidget.pic_parsed + ');'"></div>
                        <div class="text_con">
                            <div class="name" v-text="currentWidget.name"></div>
                            <div class="description" v-text="currentWidget.description"></div>
                        </div>
                    </div>
                    <div class="text_lines_container">
                        <div class="lines"></div>
                        <div class="content" v-html="currentWidget.text_con"></div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
  </div>
</template>

<script>
import Login from './login.vue';
import signupThanksVue from './signupThanks.vue';

// Entrepreneur
import EntrepreneurStepA from '@/components/signupEntrepreneur/StepA.vue'
import EntrepreneurStepB from '@/components/signupEntrepreneur/StepB.vue'
import EntrepreneurStepC from '@/components/signupEntrepreneur/StepC.vue'
import EntrepreneurStepD from '@/components/signupEntrepreneur/StepD.vue'

// Lawyer
import LawyerStepA from '@/components/signupLawyer/StepA.vue'
import LawyerStepB from '@/components/signupLawyer/StepB.vue'
import LawyerStepC from '@/components/signupLawyer/StepC.vue'
import LawyerStepD from '@/components/signupLawyer/StepD.vue'

export default {
    components: {Login, signupThanksVue, EntrepreneurStepA, EntrepreneurStepB, EntrepreneurStepC, EntrepreneurStepD, LawyerStepA, LawyerStepB, LawyerStepC, LawyerStepD },
    data() {
        return {
            actionType: 'login',
            signup_for: '',
            step: 1,
            formData: {},
            steps: [],
            token: false,
            signupDataLoading: true, 
            signup_step_content: null
        }
    },
    mounted() {
        this.api({ action: 'signup_step_content', method: 'get'}, (data)=>{
            if (data.data) {
                this.signup_step_content = data.data
            }
        })
        this.scrollToTop();
        // this.goToSign('entrepreneur');
        // setTimeout(() => {
        //     this.step = 4;
        // }, 1000);
    },
    computed: {
        currentWidget() {
            if (this.signup_step_content && this.actionType === 'signup') {
                return this.signup_step_content[this.signup_for][this.step];
            }
            return null;
        }
    },
    methods: {
        goToSign(event) {
            this.actionType = 'signup';
            this.signup_for = event;
            const prjToken = localStorage.getItem('signup_' + this.signup_for + '_token')
            if (prjToken) {
                // alert(prjToken)
                this.loadFormData(prjToken)
            }
            this.scrollToTop();
            this.signupDataLoading = false;
        },
        handleNext(formData) {
            const action = 'application_signup/add_' + this.signup_for;
            
            if (this.step === 1) formData.check_exist = true;
            // if (this.step === 1) formData.check_user_exist = true;
            if (this.token) formData.token = this.token;

            // Make the API call and handle its response within a promise to ensure proper flow control
            new Promise((resolve, reject) => {
                this.api({ action, data: formData }, async (data) => {
                    let user_exist_action = null
                    if (data.data && data.data.is_user_exist) {
                        user_exist_action = await this.confirm(this.get_word('user_alredy_sign'), "להתחברות", "נסה מייל אחר")
                        if (user_exist_action) {
                            this.step = 1;
                            this.actionType = 'login';
                            this.signupDataLoading = true;
                        } else {
                            if (this.step != 1) {
                                this.step = 1;
                                this.scrollToTop();
                            }
                            // this.step++;
                            // focus email field
                        }
                    }
                    if (user_exist_action !== null) return;

                    if (data.data && data.data.token) this.token = data.data.token;
                    if (data.data) {
                        resolve(data.data);  // Resolve the promise with the data
                    } else {
                        this.alert('הרשמה נכשלה נסה שוב מאוחר יותר');
                        reject(new Error('Registration failed'));  // Reject the promise if there's an error
                    }
                });
            }).then((data) => {
                // After the API call completes, check for user existence
                
                // if (this.step === 1 && data.is_exist) {
                //     // If user exists, confirm before proceeding
                //     this.confirm(this.get_word('alredy_sign'), this.get_word('alredy_sign_confirm'),this.get_word('alredy_sign_cancel')).then((result) => {
                //         if (result) {
                //             this.loadFormData(data.is_exist);
                //         } else {
                //             this.step++;
                //             this.scrollToTop();
                //         }
                //     });
                // } 

                if (this.step === 1) {
                    localStorage.setItem('signup_' + this.signup_for + '_token', data.token)
                }

                // If user doesn't exist or it's not the first step, proceed to the next step
                if (this.step === 4) {
                    this.step = 1;
                    this.formData = {};
                    this.actionType = 'thanks';
                } else {
                    this.step++;
                }
                this.scrollToTop();
                

            }).catch((error) => {
                console.error(error);
            });

            this.steps.push(formData);
        },
        
        loadFormData(token) {

            this.api({ action: 'application_signup/get_' + this.signup_for, data: {token}}, (data)=>{
                if (data.data) {
                    // alert(11)
                    const step = +data.data.step
                    if (step >= 4) {
                        this.step = 1
                    } else {
                        this.step = step+1;
                    }
                    delete data.data.step
                    this.formData = data.data;
                    this.token = token;
                } else {
                    localStorage.removeItem('signup_' + this.signup_for + '_token')
                }
                this.signupDataLoading = false;
            })
        }
    },

}
</script>

<style lang="scss">
.fade_s-enter-active, .fade_s-leave-active {
  transition: opacity 0.2s;
}
.fade_s-enter, .fade_s-leave-to {
  opacity: 0;
}
#background-video { position: absolute; top: 50%; left: 50%; width: 100%; height: 100%; object-fit: cover; transform: translate(-50%, -50%);}


#main_login_signup { display: flex; /*padding: 16px;*/ min-height: 100vh;padding: var(--gap_mid); background: #fff;
    .login_signup_container {flex: 3; padding: 32px 40px; display: flex; flex-direction: column; gap: 100px; overflow-y: auto;
        .head { width: 100%; display: flex; justify-content: space-between; 
            .signup_type_steps {display: flex; flex-direction: column; gap: 10px;
                .signup_type { display: flex; gap: 5px;
                    p {font-size: var(--sectionTitle); color: var(--dark_blue); font-weight: bold;}
                    span {font-size: var(--sectionTitle);color: var(--dark_blue);}
                }
                .steps { display: flex; align-items: center; gap: 5px;
                    .step {border: 1px solid var(--text_s); border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;}
                    span {color: var(--dark_blue);}
                }
            }
            .login_btn { display: flex;flex-direction: column; align-items: flex-end; gap: 10px;
                .top { display: flex; gap: 5px; 
                }
                p {color: var(--text_title);}
                a { text-decoration: underline; color: var(--dark_blue); font-weight: bold;}
            }
        }
        .signup_container { flex: 1; display: flex; justify-content: center;
            #signup { display: flex; flex-direction: column; gap: 40px; width: 46%;  min-width: 450px;
                .back { display: flex; gap: var(--gap); align-items: center;
                .arrow_container { background: var(--pageBG); border-radius: 8px; width: 36px; height: 36px; display: flex; justify-content: center; align-items: center; padding: 4px; cursor: pointer;
                    .arrow_icon { background-image: url(../assets/arrow-right.svg); background-position: center; background-size: contain; background-repeat: no-repeat; width: 100%; height: 100%;}
                }
                p { font-size: var(--h5); color: var(--text_s);}
                }
            }
        }
    }
    .text_logo_container {    position: sticky; top: var(--gap_big); height: calc(100vh - (var(--gap_big) + var(--gap_mid))); padding: var(--gap_xmid); display: flex; flex-direction: column; gap: 10vh; flex: 2; background-image: url(../assets/login_bg.png); background-size: cover; background-position: top center; display: flex;flex-direction: column; justify-content: center; align-items: center;
        .main_logo_text { z-index: 1; display: flex; flex-direction: column; gap: 24px; width: 50%; 
            .logo { background-image: url(../assets/Logo.png); background-size: contain; background-repeat: no-repeat; width: 100%;
height: 58px;
            }
            .text {
                p {text-align: center; color: #fff; font-size: 24px;}
            }
        }
        .widget { z-index: 1;
            &>div { margin: 0 auto; max-width: 55%; min-width: 444px; display: flex; flex-direction: column; }
            .privet_widget, .company_widget {
                .text_lines_container { display: flex; flex-direction: column;
                    .lines {margin-inline: calc(29px + 5px);
                        &, &::after, &::before {    transform: skew(325deg, 0deg); height: 8px; width: 29px; background: var(--green_light);  }
                        &::after, &::before { content: '';display: block; position: absolute; }
                        &::after { left: -4px; transform: translateX(-100%);}
                        &::before { right: -4px; transform: translateX(100%);}
                    }  

                    .content { color: var(--pageBG); font-size: var(--h4);  }
                } 
                .profile { display: flex;
                    .pic { position: relative;  overflow: hidden; min-width: 100px; min-height: 100px; border: 4px solid  #FFFFFF;  
                        &::after { content: ''; position: absolute; inset: 0; background-image: var(--local_url); inset: 0; background-position: center; background-size: cover; background-repeat: no-repeat;  }
                    }
                    .text_con { display: flex; flex-direction: column; 
                        &>div { font-size: var(--h5); color: var(--gray);}
                        .name { font-weight: 700; }
                        .description {}
                    }
                }
            }
            .list_widget { gap: var(--gap_xmid);
                * { color: var(--gray);}
                .widget_title { font-size: var(--h3); font-weight: 500; }
                .list_container {
                    ul { display: flex; flex-direction: column; gap: var(--gap);
                        li { font-size: var(--h4);padding-right: 40px; position: relative; 
                            &::after, &::before { content: "";
                            display: block;
                            position: absolute;
                            height: 10px;
                            width: 9px;
                            background: var(--green_light);
                            right: -8px;
                            top: 50%; }
                            &::after { transform: translateY(calc((100% * -1) - 1px)) skew(325deg, 0deg);}
                            &::before { transform: translateY(calc((0% * 1) + 1px)) skew(35deg, 0deg); }
                        }
                    }
                }
            }
            .privet_widget { gap: var(--gap_mbig);
                .text_lines_container {  gap: var(--gap); }
                .profile { gap: var(--gap_mid);  align-items: center;
                    .pic { border-radius: 50%;}
                    .text_con { 
                        .name {  }
                        .description {}
                    }
                }
            }
            .company_widget { gap: var(--gap_xmid);
                .text_lines_container {  gap: var(--gap_xmid); align-items: center; }
                .profile { flex-direction: column;  align-items: center; gap: var(--gap_mid);
                    .pic { transform: rotate(45deg); border-radius: var(--radius_m);
                        &::after { transform: rotate(-45deg); border-radius: var(--radius_m); inset: -16px; border-radius: var(--radius_m); }
                    }
                    .name, .description { text-align: center;}
                }
            }
        }
    }
}
</style>